import React from 'react'; // eslint-disable-line no-unused-vars
import { connect } from 'react-redux';
import ItemShowView from '../components/ItemShowView'
import { currentUser } from '../../reducer';
import { getItemIds, getItemsById, getCategories,getDraftItem } from '../../reducer';
import { setChangingCategory, deleteItem } from '../actions'

const mapStateToProps = (state, { match }) => {

  let account_subdomain = '';
  const account = currentUser(state).get("account");
  if (account !== undefined){
    account_subdomain = account.subdomain;
  }

  return {
    current_user_id: currentUser(state).get("id"),
    current_user: currentUser(state),
    item_ids: getItemIds(state),
    items_by_id: getItemsById(state),
    categories: getCategories(state),
    item_id: match.params.id,
    apiVars: {
      api_token: currentUser(state).get("api_token"),
      venue_permalink: getDraftItem(state).get("venue_permalink"),
      account_subdomain: account_subdomain
    }
  }
};

const mapDipatchToProps = (dispatch, ownProps) => {
  return {
    handleChangeCategoryClick: () => {
      dispatch(setChangingCategory(true))
    },
    handleChangeCategoryCancel: () => {
      dispatch(setChangingCategory(false))
    },
    handleDeleteClick: (item_id,{api_token,venue_permalink,account_subdomain}) => {

      dispatch(deleteItem(api_token,venue_permalink,account_subdomain,item_id))
    }
  }
}

function mergeProps(stateProps, dispatchProps, ownProps) {
  return Object.assign({}, ownProps, stateProps, dispatchProps, {
    handleDeleteClick: () => dispatchProps.handleDeleteClick(stateProps.item_id,stateProps.apiVars)
  })
}

export const ItemShow = connect(mapStateToProps,mapDipatchToProps,mergeProps)(ItemShowView);

export default ItemShow;



// WEBPACK FOOTER //
// ./src/snapit_app/containers/ItemShow.js